import React, { useEffect } from 'react';
import { styles } from './styles';
import ReflectionButton from '../../components/reflectionButton/reflectionButton';
import { RIPPLE_ON_DARK, RIPPLE_ON_LIGHT } from '../../globalStyles';
import { pad2, scrollToId } from '../../utils';

const SHIMMER_CSS = `
  .shimmer-word {
    background: linear-gradient(90deg, var(--shimmer-base) 0%, var(--shimmer-band) 50%, var(--shimmer-base) 100%);
    background-size: 150% auto;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    -webkit-box-decoration-break: clone;
    box-decoration-break: clone;
    animation: shimmer 10s linear infinite;
  }
`;

const CAPABILITIES = ['Custom Software', 'Web Development', 'AI Systems', 'Game Development'];

const Intro: React.FC = () => {
  useEffect(() => {
    const id = 'shimmer-style';
    if (!document.getElementById(id)) {
      const el = document.createElement('style');
      el.id = id;
      el.textContent = SHIMMER_CSS;
      document.head.appendChild(el);
    }
  }, []);

  return (
    <section id="intro" style={styles.section}>
      <div style={styles.content}>
        <h1 className="shimmer-word" style={styles.headline}>
          Where tomorrow
          <br />
          is built
        </h1>
        <p style={styles.sub}>
          Novaeon, alongside its own products, builds custom software, web platforms, AI
          systems, and games for the businesses it partners with.
        </p>
        <div style={styles.actions}>
          <ReflectionButton
            style={styles.btnPrimary}
            highlightColor={RIPPLE_ON_LIGHT}
            onClick={() => scrollToId('services')}
          >
            Explore services
          </ReflectionButton>
          <ReflectionButton
            style={styles.btnGhost}
            highlightColor={RIPPLE_ON_DARK}
            onClick={() => scrollToId('products')}
          >
            See what we're building →
          </ReflectionButton>
        </div>

        <div className="spec-strip" style={styles.specStrip}>
          {CAPABILITIES.map((c, i) => (
            <div key={c} style={styles.specItem}>
              <span style={styles.specIndex}>{pad2(i)}</span>
              <span style={styles.specLabel}>{c}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Intro;
